__turbopack_context__.v({
  "deskNone": "pZbccW_deskNone",
  "email_btn": "pZbccW_email_btn",
  "facebook_btn": "pZbccW_facebook_btn",
  "list_share_icons": "pZbccW_list_share_icons",
  "mobNone": "pZbccW_mobNone",
  "share_icon_btn": "pZbccW_share_icon_btn",
  "share_sheet": "pZbccW_share_sheet",
  "sms_btn": "pZbccW_sms_btn",
  "telegram_btn": "pZbccW_telegram_btn",
  "twitter_btn": "pZbccW_twitter_btn",
  "whatsapp_btn": "pZbccW_whatsapp_btn",
});
